// Generated by spriteMerger.js
import { ComponentProps } from 'react';
import Icon from '../Icon';
import maps from './maps.svg';

interface MapsIconProps extends Omit<ComponentProps<typeof Icon>, 'link'> {
  name: MapsNames;
}

export function MapsIcon({ name, ...props }: MapsIconProps) {
  return <Icon {...props} link={maps} name={name} />
}

type MapsNames =
  | '360'
  | 'add_business'
  | 'add_location_alt'
  | 'add_location'
  | 'add_road'
  | 'agriculture'
  | 'airline_stops'
  | 'airlines'
  | 'alt_route'
  | 'atm'
  | 'attractions'
  | 'badge'
  | 'bakery_dining'
  | 'beenhere'
  | 'bike_scooter'
  | 'breakfast_dining'
  | 'brunch_dining'
  | 'bus_alert'
  | 'car_crash'
  | 'car_rental'
  | 'car_repair'
  | 'castle'
  | 'category'
  | 'celebration'
  | 'church'
  | 'cleaning_services'
  | 'compass_calibration'
  | 'connecting_airports'
  | 'crisis_alert'
  | 'delivery_dining'
  | 'departure_board'
  | 'design_services'
  | 'diamond'
  | 'dinner_dining'
  | 'directions_bike'
  | 'directions_boat_filled'
  | 'directions_boat'
  | 'directions_bus_filled'
  | 'directions_bus'
  | 'directions_car_filled'
  | 'directions_car'
  | 'directions_railway_filled'
  | 'directions_railway'
  | 'directions_run'
  | 'directions_subway_filled'
  | 'directions_subway'
  | 'directions_transit_filled'
  | 'directions_transit'
  | 'directions_walk'
  | 'directions'
  | 'dry_cleaning'
  | 'edit_attributes'
  | 'edit_location_alt'
  | 'edit_location'
  | 'edit_road'
  | 'egg_alt'
  | 'egg'
  | 'electric_bike'
  | 'electric_car'
  | 'electric_moped'
  | 'electric_rickshaw'
  | 'electric_scooter'
  | 'electrical_services'
  | 'emergency_recording'
  | 'emergency_share'
  | 'emergency'
  | 'ev_station'
  | 'factory'
  | 'fastfood'
  | 'festival'
  | 'flight_class'
  | 'flight'
  | 'forest'
  | 'fork_left'
  | 'fork_right'
  | 'fort'
  | 'hail'
  | 'handyman'
  | 'hardware'
  | 'home_repair_service'
  | 'hotel'
  | 'hvac'
  | 'icecream'
  | 'kebab_dining'
  | 'layers_clear'
  | 'layers'
  | 'liquor'
  | 'local_activity'
  | 'local_airport'
  | 'local_atm'
  | 'local_bar'
  | 'local_cafe'
  | 'local_car_wash'
  | 'local_convenience_store'
  | 'local_dining'
  | 'local_drink'
  | 'local_fire_department'
  | 'local_florist'
  | 'local_gas_station'
  | 'local_grocery_store'
  | 'local_hospital'
  | 'local_hotel'
  | 'local_laundry_service'
  | 'local_library'
  | 'local_mall'
  | 'local_movies'
  | 'local_offer'
  | 'local_parking'
  | 'local_pharmacy'
  | 'local_phone'
  | 'local_pizza'
  | 'local_play'
  | 'local_police'
  | 'local_post_office'
  | 'local_printshop'
  | 'local_see'
  | 'local_shipping'
  | 'local_taxi'
  | 'lunch_dining'
  | 'map'
  | 'maps_ugc'
  | 'medical_information'
  | 'medical_services'
  | 'menu_book'
  | 'merge'
  | 'minor_crash'
  | 'miscellaneous_services'
  | 'mode_of_travel'
  | 'money'
  | 'moped'
  | 'mosque'
  | 'moving'
  | 'multiple_stop'
  | 'museum'
  | 'my_location'
  | 'navigation'
  | 'near_me_disabled'
  | 'near_me'
  | 'nightlife'
  | 'no_crash'
  | 'no_meals'
  | 'no_transfer'
  | 'not_listed_location'
  | 'park'
  | 'pedal_bike'
  | 'person_pin_circle'
  | 'person_pin'
  | 'pest_control_rodent'
  | 'pest_control'
  | 'pin_drop_outline'
  | 'pin_drop'
  | 'plumbing'
  | 'railway_alert'
  | 'ramen_dining'
  | 'ramp_left'
  | 'ramp_right'
  | 'rate_review'
  | 'remove_road'
  | 'restaurant_menu'
  | 'restaurant'
  | 'roundabout_left'
  | 'roundabout_right'
  | 'route'
  | 'run_circle'
  | 'safety_check'
  | 'sailing'
  | 'satellite'
  | 'screen_rotation_alt'
  | 'set_meal'
  | 'signpost'
  | 'snowmobile'
  | 'sos'
  | 'soup_kitchen'
  | 'stadium'
  | 'store_mall_directory'
  | 'straight'
  | 'streetview'
  | 'subway'
  | 'synagogue'
  | 'takeout_dining'
  | 'taxi_alert'
  | 'temple_buddhist'
  | 'temple_hindu'
  | 'terrain'
  | 'theater_comedy'
  | 'tire_repair'
  | 'traffic'
  | 'train'
  | 'tram'
  | 'transfer_within_a_station'
  | 'transit_enterexit'
  | 'trip_origin'
  | 'turn_left'
  | 'turn_right'
  | 'turn_sharp_left'
  | 'turn_sharp_right'
  | 'turn_slight_left'
  | 'turn_slight_right'
  | 'two_wheeler'
  | 'u_turn_left'
  | 'u_turn_right'
  | 'volunteer_activism'
  | 'warehouse'
  | 'wine_bar'
  | 'wrong_location'
  | 'zoom_in_map'
  | 'zoom_out_map'
;

